import { render, staticRenderFns } from "./IconArrowLeft.vue?vue&type=template&id=6bedb695"
import script from "./IconArrowLeft.vue?vue&type=script&lang=js"
export * from "./IconArrowLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports